import { render } from "./LoveIt.vue?vue&type=template&id=0de534d1"
import script from "./LoveIt.vue?vue&type=script&lang=js"
export * from "./LoveIt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__